import { SuggestionsPanel } from "@components/campaigns/SuggestionsPanel";
import { NotesPanel } from "@components/shared/NotesPanel";
import { ArtefactGrid, type CampaignArtefact } from "./ArtefactGrid";
import type { WorkflowArtefactStatus } from "./context";
import { useCampaignDetail } from "./context";
import { WorkflowStatus } from "./WorkflowStatus";

// Campaign landing surface (#2220). The pipeline and team blocks that used to
// live here moved to RUN › Pipeline and the Team tab respectively once the
// DEFINE/RUN surfaces gained their own navigation. What's left is the only
// at-a-glance artefact dashboard (phase-grouped tiles) plus the campaign-level
// suggestions and pinned notes, which have no other home.
export function OverviewTab() {
  const { campaign, refresh } = useCampaignDetail();
  const artefacts = (campaign.artefacts ?? []) as CampaignArtefact[];
  const workflowItems = (campaign.workflowStatus ?? []) as WorkflowArtefactStatus[];

  return (
    <div className="space-y-8">
      {workflowItems.length > 0 && <WorkflowStatus items={workflowItems} />}

      <ArtefactGrid artefacts={artefacts} />

      <section>
        <h2 className="mb-3 text-xs font-semibold uppercase tracking-wider text-text-muted">
          AI Suggestions
        </h2>
        <div className="rounded-lg bg-card p-4 shadow-sm ring-1 ring-ring">
          <div className="max-h-60 overflow-y-auto" data-testid="suggestions-scroll-region">
            <SuggestionsPanel
              suggestions={(campaign.campaignSuggestions ?? []) as never[]}
              onChanged={refresh}
            />
          </div>
        </div>
      </section>

      <section>
        <h2 className="mb-3 text-xs font-semibold uppercase tracking-wider text-text-muted">
          Pinned notes
        </h2>
        <NotesPanel
          notableType="Campaign"
          notableId={campaign.id}
          notes={(campaign.attachedNotes ?? []) as never[]}
          onChanged={refresh}
        />
      </section>
    </div>
  );
}
